import React, { useEffect, useState } from 'react';
import { MyAccountContainer, AccountInfoContainer, UserInfo } from './styled';
import { images } from '../../Constants/ImageUrls';
import { userDataFetcher } from '../../datafetchers/productPage/userDataFetcher';
import GlobalStyle from '../../styles/globalStylesV2';
import Cookies from 'js-cookie';
import { navigateToCartPage } from '../../Utils/redirections';

const MyAccount = (props) => {
  const { setCartItems } = props;
  const [userData, setUserData] = useState(null);
  const [showLogout, setShowLogout] = useState(false);

  const baseSections = [
    {
      heading: 'Manage',
      options: [
        {
          id: 1,
          title: 'My Orders',
          url: '/my-orders',
          imageUrl:
            'https://images.myloapp.in/NestJsUploads/1743142111059-my-orders.webp',
        },
        {
          id: 2,
          title: 'Track My Order',
          url: userData?.user?.orderIds?.length
            ? `/store/orderinfo/${userData.user.orderIds[0]}`
            : '/https://app.mylofamily.com/NUX_FLOW_GROWTH_TRACKER_UTM?utm_source=web&utm_medium=web',
          imageUrl:
            'https://images.myloapp.in/NestJsUploads/1743142160798-track-my-order.webp',
        },
        {
          id: 3,
          title: 'My Cart',
          url: '',
          imageUrl:
            'https://images.myloapp.in/NestJsUploads/1743142195870-cart.webp',
          openCart: true,
        },
        {
          id: 4,
          title: (
            <div className="MyloCashInfo">
              Mylo Cash Balance
              <span
                style={{
                  backgroundColor: '#7fdd92',
                  borderRadius: '4px',
                  padding: '0px 5px',
                  margin: '0px 6px',
                  fontWeight: 'bold',
                }}
              >
                {'₹' + userData?.user.mylo_cash || 0}
              </span>
              <br />{' '}
              <p
                style={{
                  color: '#2c2d2e',
                  fontSize: '12px',
                  margin: '4px 0',
                }}
              >
                Can be redeemed inside app to <br /> claim additional discount
                on orders
              </p>
              <p
                style={{
                  color: '#ef4e5e',
                  fontSize: '14px',
                  margin: '4px 0',
                  fontWeight: 'bold',
                }}
              >
                Download App Now
              </p>
            </div>
          ),
          url: 'https://app.mylofamily.com/NUX_FLOW_GROWTH_TRACKER_UTM?utm_source=web&utm_medium=web',
          imageUrl:
            'https://images.myloapp.in/NestJsUploads/1743142228964-wallet.webp',
        },
      ],
    },
    {
      heading: 'Others',
      options: [
        {
          id: 1,
          title: 'Contact Us',
          url: '/contact-us',
          imageUrl:
            'https://images.myloapp.in/NestJsUploads/1743142273397-contct-us.webp',
        },
        {
          id: 2,
          title: 'About Us',
          url: '/about-us',
          imageUrl:
            'https://images.myloapp.in/NestJsUploads/1743141945999-about-us.webp',
        },
      ],
    },
  ];

  const sections = baseSections.map((section) => ({
    ...section,
    options: section.options.filter(
      (option) =>
        option.title !== 'Track My Order' || userData?.user?.orderIds?.length,
    ),
  }));

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await userDataFetcher();
        setUserData(response);
        console.log('User Data:', response);
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  const handleOptionClick = (option) => {
    if (option.openCart) {
      navigateToCartPage();
    } else {
      window.location.href = option.url;
    }
  };

  const handleLogout = () => {
    __KP_LOGIN_SDK_INSTANCE__.handleKPLogout();
    sessionStorage.setItem('kwikpass_sso_tooltip', 'false');
    Cookies.remove('token', '/');
    Cookies.remove('cart_items', '/');
    if (setCartItems) setCartItems([]);
    window.location.href = '/';
    setShowLogout(true);
  };

  return (
    <>
      <GlobalStyle />
      <MyAccountContainer>
        <UserInfo>
          <img
            src={
              userData?.user.profile_image
                ? `${userData.user.profile_image}?t=${new Date().getTime()}`
                : null
            }
            alt="dp"
            width="53px"
            height="53px"
          />

          <div className="username">
            <h3>{userData?.user.fullname || 'Guest User'}</h3>
            <p>
              Mylo member since{' '}
              {userData?.user.created_at
                ? new Date(userData.user.created_at).toLocaleDateString(
                    'en-US',
                    {
                      month: 'long',
                      year: 'numeric',
                    },
                  )
                : 'N/A'}
            </p>
          </div>
        </UserInfo>
        {sections.map((section) => (
          <React.Fragment key={section.heading}>
            <span className="InfoHeading">{section.heading}</span>
            <AccountInfoContainer>
              {section.options.map((option) => (
                <div
                  className="AccountInfo"
                  key={option.id}
                  onClick={() => handleOptionClick(option)}
                  style={{ cursor: 'pointer' }}
                >
                  <>
                    <img
                      src={option.imageUrl}
                      alt="home"
                      width="25px"
                      height="25px"
                    />
                    <p>{option.title} </p>
                    <div className="infoPath">
                      <img
                        src={images.arrowforward}
                        alt="arrowForward"
                        width="14px"
                        height="14px"
                      />
                    </div>
                  </>
                </div>
              ))}
            </AccountInfoContainer>
          </React.Fragment>
        ))}
        <button className="Log-out" onClick={handleLogout}>
          Log out
        </button>
      </MyAccountContainer>
    </>
  );
};

export default MyAccount;
